export const lebensitutationssteinAction = ({
    updateData,
    selectDialogContainer,
    openDialog,
    closeDialog,
}) => {
    return {
        ADD_LIFESTONE: payload => {
            updateData(payload, "/appstate/selectedLifestone")
            selectDialogContainer("Add Lifestone")
            openDialog()
        },
        ADD_LIFESTONE_ABORT: () => {
            updateData({}, "/appstate/selectedLifestone")
            closeDialog()
        },
        ADD_LIFESTONE_SUCCESS: () => {
            closeDialog()
        }
    }
}
